module.exports = __webpack_public_path__ + "img/cc_slo_logo.678e404e.svg";